import React from "react";

export function useOutsideClickDetection(
  ref: React.MutableRefObject<any>,
  callback: (target?: any) => void,
  isOpen?: boolean
) {
  React.useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event.target);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, isOpen]); // eslint-disable-line react-hooks/exhaustive-deps
}
